export const DEEPLINKS_REDIRECT_URL =
  '//vod.wix.com/public/widgets/deeplinks/active/redirect';
export const IS_LOCAL = process.env.NODE_ENV === 'development';
